import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ClearingCompany } from 'src/app/core/models/clearing-company';
import { ClearingCompanyService } from 'src/app/core/services/general/clearing-company.service';
import { CreateClearingCompanyModalComponent } from '../create-clearing-company-modal/create-clearing-company-modal.component';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-clearing-company-input',
  templateUrl: './clearing-company-input.component.html',
  styleUrls: ['./clearing-company-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ClearingCompanyInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ClearingCompanyInputComponent,
    },
  ],
})
export class ClearingCompanyInputComponent {
  @Input()
  title = "Select Clearing Company...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public clearingCompaniesList: Array<CustomSelectOption> = [];

  constructor(
    private clearingCompanyService: ClearingCompanyService,
    private modalService: NgbOffcanvas,
  ) {
    this.clearingCompanyService
      .all()
      .subscribe((res: Array<ClearingCompany>) => {
        this.clearingCompaniesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.clearingCompaniesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }


  createNewClearingCompany() {
    const modalRef = this.modalService.open(CreateClearingCompanyModalComponent, {
      position: 'end',
      panelClass: "w-75"
    });
    modalRef.result.then(() => {
      let createdClearingCompanyString = localStorage.getItem('created-clearing-company');
      if (createdClearingCompanyString) {
        localStorage.removeItem('created-clearing-company');
        let createdClearingCompany = new ClearingCompany(JSON.parse(createdClearingCompanyString)!);
        this.clearingCompaniesList.push({
          name: `${createdClearingCompany.name}`,
          value: createdClearingCompany.uuid,
        });
        this.onValueChange(this.clearingCompaniesList.filter((el) => el.value == createdClearingCompany.uuid)[0])
      }
    });
  }
}
